export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
  MaintenanceWork = 'MaintenanceWork',
  WebsiteShare = 'WebsiteShare',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
